module.exports = __webpack_public_path__ + "images/emoji/leaves.a1af9dc4a33160b3e919.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/leaves.png
// module id = 2y0Z
// module chunks = 14